import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './modules/layout/sidebar/layout.component';
import { AuthGuard } from './shared/guards/auth-guard.service';
import { MaintenanceComponent } from './modules/maintenance/maintenance.component';

const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		children: [
			{ path: '', redirectTo: 'patients', pathMatch: 'full' },
			{
				path: 'dashboard',
				loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashBoardModule),
				data: { breadcrumb: 'Dashboard' }
				// data: { breadcrumb: 'Dashboard', roles: [''] },
				// canActivate: [AuthGuard]
			},
			{
				path: 'patients',
				loadChildren: () => import('./modules/patients/patients.module').then((m) => m.PatientsModule),
				data: { breadcrumb: 'Patient' }
				// data: { breadcrumb: 'Patients', roles: ['patient_manager_1'] },
				// canActivate: [AuthGuard]
			},
			{
				path: 'customer-orders',
				loadChildren: () =>
					import('./modules/customer-orders/customer-orders.module').then((m) => m.CustomerOrdersModule),
				data: { breadcrumb: 'Customer Order' }
				// data: { breadcrumb: 'Customer Orders', roles: [''] },
				// canActivate: [AuthGuard]
			},
			{
				path: 'inventory',
				loadChildren: () => import('./modules/inventory/inventory.module').then((m) => m.InventoryModule),
				data: { breadcrumb: 'Inventory' }
			},
			{
				path: 'inbound-processing',
				loadChildren: () =>
					import('./modules/inbound-processing/inbound-processing.module').then(
						(m) => m.InboundProcessingModule
					),
				data: { breadcrumb: 'Inbound Processing' }
			},
			{
				path: 'inbound-communication',
				loadChildren: () =>
					import('./modules/inbound-communication').then((m) => m.InboundCommunicationModule),
				data: { breadcrumb: 'Inbound Communication' }
			},
			{
				path: 'data-management',
				loadChildren: () =>
					import('./modules/inbound-data-management').then((m) => m.InboundDataManagementModule),
				data: { breadcrumb: 'Inbound Data Management' }
			},
			{
				path: 'inbound-order',
				loadChildren: () =>
					import('./modules/inbound-processing/inbound-order-detail.module').then(
						(m) => m.InboundOrderDetailModule
					),
				data: { breadcrumb: 'Inbound Order Detail' }
			},
			{
				path: 'purchase-order',
				loadChildren: () =>
					import('./modules/purchase-order/purchase-order.module').then((m) => m.PurchaseOrderModule),
				data: { breadcrumb: 'Purchase Order' }
			},
			{
				path: 'switch-out',
				loadChildren: () => import('./modules/switch-out/switch-out.module').then((m) => m.SwitchOutModule),
				data: { breadcrumb: 'Switch Out' }
			},
			{
				path: 'switchout-direct',
				loadChildren: () =>
					import('./modules/switchout-direct/switchout-direct.module').then((m) => m.SwitchoutDirectModule),
				data: { breadcrumb: 'Switch Out Direct' }
			},
			{
				path: 'driver',
				loadChildren: () => import('./modules/driver/driver.module').then((m) => m.DriverModule),
				data: {
					breadcrumb: 'Driver',
					roles: ['Admin', 'driver', 'vehicle_manager_1', 'vehicle_manager_2', 'vehicle_manager_3']
				},
				canActivate: [AuthGuard]
			},
			{
				path: 'admin',
				loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
				data: { breadcrumb: 'Admin' }

				//NHL NOTE: This is how to block route based on users permission and roles
				//NHL NOTE: for single permission or role use singular with string, for multiple use plural with with array
				//NHL NOTE: you can use either or both permissions and roles
				// data: { breadcrumb: 'Admin', roles: ['admin', 'product_managers'] },
				// canLoad: [AuthGuard],
			},
			{
				path: 'billing',
				loadChildren: () => import('./modules/billing/billing.module').then((m) => m.BillingModule),
				data: { breadcrumb: 'Billing' }
			},
			{
				path: 'amps-fix',
				loadChildren: () => import('./modules/amps-fix/amps-fix.module').then((m) => m.AmpsFixModule),
				data: { breadcrumb: 'AMPS Fix' }
			},
			{
				path: 'asset-owner',
				loadChildren: () => import('./modules/asset-owner/asset-owner.module').then((m) => m.AssetOwnerModule),
				data: { breadcrumb: 'Asset Owner' }
			},
			{
				path: 'asset-branch-transfer',
				loadChildren: () =>
					import('./modules/asset-branch-transfer/asset-branch-transfer.module').then(
						(m) => m.AssetBranchTransferModule
					),
				data: { breadcrumb: 'Asset Branch Transfer' }
			},
			{
				path: 'non-locatable-to-located',
				loadChildren: () =>
					import('./modules/non-locatable-to-located/non-locatable-to-located.module').then(
						(m) => m.NonLocatableToLocatedModule
					),
				data: { breadcrumb: 'Non-Locatable to Located' }
			},
			{
				path: 'reports',
				loadChildren: () =>
					import('./modules/reports/company-reports/company-reports.module').then(
						(m) => m.CompanyReportsModule
					),
				data: { breadcrumb: 'Reports' }
			},
			{
				path: 'no-access',
				loadChildren: () => import('./modules/no-access/no-access.module').then((m) => m.NoAccessModule),
				data: { breadcrumb: 'No Access' }
			}
		]
	},
	{
		path: 'auth',
		loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
		data: { breadcrumb: 'Auth' }
	},
	// Eager (not lazy) so it still renders when the network is down and chunks can't be fetched.
	{ path: 'maintenance', component: MaintenanceComponent },
	{ path: '**', redirectTo: '/' }
];

@NgModule({
	// DOVE-2676 — 'computed' so a navigation cancelled by a guard (e.g. Back during a bulk access
	// undo countdown) restores the browser history instead of overwriting the previous entry.
	imports: [RouterModule.forRoot(routes, { canceledNavigationResolution: 'computed' })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
